export const CoreDataSecurityApplicationsBulkName = 'CoreDataSecurityApplicationsBulk';
